<template>
  <v-card id="table-firebase">
    <v-card-title id="card-title" ref="card-title">
      <v-checkbox
        :value="selectedAll"
        color="#6ec39b"
        :label="`เอกสารที่เลือก ${selectedList.length} ฉบับ `"
        @change="clickSelectedAll($event)"
      ></v-checkbox>

      <!-- <v-btn text :color="selectedList.filter((x) => !x.pdfUrl).length > 0 ? '#c9242b': '#6ec39b'" class="ml-10" @click.prevent="downloadPDF"
             :disabled="selectedList.length < 1 || downloadingPdf || selectedList.filter((x) => x.pdfUrl).length < 1"
             :loading="downloadingPdf">
        <img
          :src="selectedList.filter((x) => !x.xmlUrl).length > 0 && selectedList.filter((x) => x.xmlUrl).length >= 1 ? '/images/icons/icon_download_pdf_red.svg': '/images/icons/icon_download_pdf.svg'"
          style="max-height: 26px; max-width: 26px;"
          class="mr-2"
        />
        <span>ดาวน์โหลด PDF {{ `(${selectedList.filter((x) => x.pdfUrl).length})` }}</span>
      </v-btn> -->
      <v-btn text :color="selectedList.length > 0 ? '#6ec39b': '#6ec39b'" class="ml-10" @click.prevent="clickExportWHTTxtSelected('tmb')"
             :disabled="selectedList.length < 1"
             :loading="downloadingPdf">
        <img
          :src="selectedList.length > 0  ? '/images/icons/icon_download_pdf.svg': '/images/icons/icon_download_pdf.svg'"
          style="max-height: 26px; max-width: 26px;"
          class="mr-2"
        />
        <span>TMB {{ `(${selectedList.length})` }}</span>
      </v-btn>
      <v-btn text :color="selectedList.length > 0 ? '#6ec39b': '#6ec39b'" class="ml-10" @click.prevent="clickExportWHTTxtSelected('ktb')"
             :disabled="selectedList.length < 1"
             :loading="downloadingPdf">
        <img
          :src="selectedList.length > 0  ? '/images/icons/icon_download_pdf.svg': '/images/icons/icon_download_pdf.svg'"
          style="max-height: 26px; max-width: 26px;"
          class="mr-2"
        />
        <span>KTB {{ `(${selectedList.length})` }}</span>
      </v-btn>
      <v-btn text :color="selectedList.length > 0 ? '#6ec39b': '#6ec39b'" class="ml-10" @click.prevent="clickExportWHTTxtSelected('bbl')"
             :disabled="selectedList.length < 1"
             :loading="downloadingPdf">
        <img
          :src="selectedList.length > 0  ? '/images/icons/icon_download_pdf.svg': '/images/icons/icon_download_pdf.svg'"
          style="max-height: 26px; max-width: 26px;"
          class="mr-2"
        />
        <span>BBL {{ `(${selectedList.length})` }}</span>
      </v-btn>
      <v-btn text :color="selectedList.length > 0 ? '#6ec39b': '#6ec39b'" class="ml-10" @click.prevent="clickExportWHTKbankTxtSelected('dct')"
             :disabled="selectedList.length < 1"
             :loading="downloadingPdf">
        <img
          :src="selectedList.length > 0  ? '/images/icons/icon_download_pdf.svg': '/images/icons/icon_download_pdf.svg'"
          style="max-height: 26px; max-width: 26px;"
          class="mr-2"
        />
        <span>KBANK DCT {{ `(${selectedList.length})` }}</span>
      </v-btn>
      <v-btn text :color="selectedList.length > 0 ? '#6ec39b': '#6ec39b'" class="ml-10" @click.prevent="clickExportWHTKbankTxtSelected('mcl')"
             :disabled="selectedList.length < 1"
             :loading="downloadingPdf">
        <img
          :src="selectedList.length > 0  ? '/images/icons/icon_download_pdf.svg': '/images/icons/icon_download_pdf.svg'"
          style="max-height: 26px; max-width: 26px;"
          class="mr-2"
        />
        <span>KBANK MCL {{ `(${selectedList.length})` }}</span>
      </v-btn>
      <v-btn text :color="selectedList.length > 0 ? '#6ec39b': '#6ec39b'" class="ml-10" @click.prevent="clickExportWHTKbankTxtSelected('ftl')"
             :disabled="selectedList.length < 1"
             :loading="downloadingPdf">
        <img
          :src="selectedList.length > 0  ? '/images/icons/icon_download_pdf.svg': '/images/icons/icon_download_pdf.svg'"
          style="max-height: 26px; max-width: 26px;"
          class="mr-2"
        />
        <span>KBANK FTL {{ `(${selectedList.length})` }}</span>
      </v-btn>
      <!-- <v-dialog v-model="exportDialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <button
            v-bind="attrs"
            v-on="on"
            class="tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
            style="font-size: 0.875rem;"
          >ส่งออกข้อมูล</button>
        </template>
        <template>
          <v-form ref="form" v-model="emailValid">
            <v-card>
              <v-card-title>
                <b>ส่งออกข้อมูล</b>
              </v-card-title>
              <v-card-text>
                <v-menu
                  v-model="menuDatePickerStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateExportStart"
                      label="วันที่เอกสารเริ่มต้น"
                      append-icon="mdi-keyboard_arrow_down"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateExportStart" @input="menuDatePickerStart = false"></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="menuDatePickerEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateExportEnd"
                      label="วันที่เอกสารสิ้นสุด"
                      append-icon="mdi-keyboard_arrow_down"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateExportEnd" @input="menuDatePickerEnd = false"></v-date-picker>
                </v-menu>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancelExportDialog">
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn text color="#6ec39b" type="button" class="btn-submit" @click="exportDocs">
                  <b>ส่งออกข้อมูล</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog> -->

      <v-spacer></v-spacer>

      <!-- <popover-menu
        style="padding-right: 20px;"
        buttonText="กรอง"
        titleText="แสดงเอกสารเฉพาะ"
        :option-list="optionFilterList"
        :value-list="valueFilterList"
        @change-value-filter-list="onChangeValueFilterList"
        buttonIcon="/images/icons/icon_filter.svg"
        :defaultListItem="defaultValueFilterList"
        :disablePopOver="disablePopOver"
      ></popover-menu>

      <popover-menu
        style="padding-right: 20px;"
        buttonText="ซ่อน"
        titleText="เลือกคอลัมน์ที่ต้องการซ่อน"
        :option-list="optionHideList"
        :value-list="valueHideList"
        @change-value-filter-list="onChangeValueDropdownHideColumn"
        buttonIcon="/images/icons/icon_hidden.svg"
        :defaultListItem="defaultValueHideList"
      ></popover-menu>

      <div class="search-box">
        <v-text-field :value="keyword" append-icon="mdi-magnify" placeholder="ค้นหา" outlined @input="debounceInput"></v-text-field>
      </div> -->
    </v-card-title>

    <v-container v-if="alert.show">
      <v-row>
        <v-col cols="12">
          <v-alert v-model="alert.show" :type="alert.type" transition="scale-transition" dismissible>{{ alert.text }}</v-alert>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="pdfDialog">
      <div>
        <iframe class="iframe" :src="pdfSrc"></iframe>
      </div>
    </v-dialog>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr id="header-table">
            <th />
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('paymentDocDate')"
              v-if="[showColumn('paymentDocDate'), defaultOrder( 'paymentDocDate')]"
            >
              วันที่เอกสาร
              <img
                v-if="((orderBySelect['key'] === 'paymentDocDate') && !keyword)"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{'filter-up' : (orderBySelect['value'] === 'asc')}"
                style="margin-left:4px; display: inline-flex;"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'paymentDocDate' && !keyword"
                class="icon-sort"
              >mdi-menu-swap</v-icon>
            </th>
            <th class="text-left order-by-row" @click="changeOrderBy('payeeTaxID')">
              เลขผู้เสียภาษี
              <img
                v-if="((orderBySelect['key'] === 'payeeTaxID') && !keyword)"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{'filter-up' : (orderBySelect['value'] === 'asc')}"
                style="margin-left:4px; display: inline-flex;"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'payeeTaxID' && !keyword"
                class="icon-sort"
              >mdi-menu-swap</v-icon>
            </th>
            <th class="text-left order-by-row" @click="changeOrderBy('payeeReference')" v-if="showColumn('payeeReference')">
              อ้างอิงเอกสารเลขที่
              <img
                v-if="((orderBySelect['key'] === 'payeeReference')&& !keyword)"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{'filter-up' : (orderBySelect['value'] === 'asc')}"
                style="margin-left:4px; display: inline-flex;"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'payeeReference' && !keyword"
                class="icon-sort"
              >mdi-menu-swap</v-icon>
            </th>
            <th class="text-left order-by-row" @click="changeOrderBy('payeeName')" v-if="showColumn('payeeName')">
              ชื่อผู้ขาย / ชื่อบริษัท
              <img
                v-if="((orderBySelect['key'] === 'payeeName')&& !keyword)"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{'filter-up' : (orderBySelect['value'] === 'asc')}"
                style="margin-left:4px; display: inline-flex;"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'payeeName'&& !keyword"
                class="icon-sort"
              >mdi-menu-swap</v-icon>
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('whtAmount')"
              v-if="showColumn('whtAmount')"
            >
              จำนวนเงินภาษีหัก ณ ที่จ่าย
              <img
                v-if="((orderBySelect['key'] === 'whtAmount')&& !keyword)"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{'filter-up' : (orderBySelect['value'] === 'asc')}"
                style="margin-left:4px; display: inline-flex;"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'whtAmount'&& !keyword"
                class="icon-sort"
              >mdi-menu-swap</v-icon>
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('invoiceVatAmount')"
              v-if="showColumn('invoiceVatAmount')"
            >
              ภาษีมูลค่าเพิ่ม
              <img
                v-if="((orderBySelect['key'] === 'invoiceVatAmount')&& !keyword)"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{'filter-up' : (orderBySelect['value'] === 'asc')}"
                style="margin-left:4px; display: inline-flex;"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'invoiceVatAmount'&& !keyword"
                class="icon-sort"
              >mdi-menu-swap</v-icon>
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('invoiceBaseAmount')"
              v-if="showColumn('invoiceBaseAmount')"
            >
              มูลค่าที่นำมาคิดภาษีหัก ณ ที่จ่าย
              <img
                v-if="((orderBySelect['key'] === 'invoiceBaseAmount')&& !keyword)"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{'filter-up' : (orderBySelect['value'] === 'asc')}"
                style="margin-left:4px; display: inline-flex;"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'invoiceBaseAmount'&& !keyword"
                class="icon-sort"
              >mdi-menu-swap</v-icon>
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('invoiceTotalNetAmount')"
              v-if="showColumn('invoiceTotalNetAmount')"
            >
              จำนวนเงินสุทธิ
              <img
                v-if="((orderBySelect['key'] === 'invoiceTotalNetAmount')&& !keyword)"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{'filter-up' : (orderBySelect['value'] === 'asc')}"
                style="margin-left:4px; display: inline-flex;"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'invoiceTotalNetAmount'&& !keyword"
                class="icon-sort"
              >mdi-menu-swap</v-icon>
            </th>
            <!-- <th class="text-center" style="min-width: 80px;" v-if="showColumn('@DBSaleDocID')">เลขที่ใบกำกับภาษี</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in docs" :key="doc.id" class="tr-data">
            <td>
              <v-checkbox
                color="#6ec39b"
                :input-value="getCheckedSelect(doc.id)"
                class="remove-checkbox-padding"
                @change="clickSelected(doc)"
              ></v-checkbox>
            </td>
            <td
              v-if="showColumn('paymentDocDate')"
              :disabled="downloadPdfLoading"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <div class="check-box-flex">
                <img
                  v-if="doc['@DownloadedXml']"
                  src="/images/icons/icon_downloaded.svg"
                  alt="downloaded"
                  class="icon-downloaded"
                />
                <span>{{ getDateWithFormat(doc['paymentDocDate']) }}</span>
              </div>
            </td>
            <td
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >{{ doc['payeeTaxID'] }}</td>
            <td
              v-if="showColumn('payeeReference')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >{{ doc['payeeReference'] }}</td>
            <td
              v-if="showColumn('payeeName')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >{{doc['payeeName']}}</td>
            <td
              class="text-right"
              v-if="showColumn('whtAmount')"
              v-html="getFormatAmount(doc['whtAmount'])"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
            <td
              class="text-right"
              v-if="showColumn('invoiceVatAmount')"
              v-html="getFormatAmount(doc['invoiceVatAmount'])"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
            <td
              class="text-right"
              v-if="showColumn('invoiceBaseAmount')"
              v-html="getFormatAmount(doc['invoiceBaseAmount'])"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
                        <td
              class="text-right"
              v-if="showColumn('invoiceTotalNetAmount')"
              v-html="getFormatAmount(doc['invoiceTotalNetAmount'])"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>

          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-progress-linear indeterminate color="green" :active="loading || downloadPdfLoading"></v-progress-linear>
    <div class="float-left mt-2" v-if="!showPaginationTemplate">
      <div class="tw-relative">
        <v-btn
          class="ma-2 page-arrow-size"
          outlined
          color="#707070"
          @click="onClickPreviousPagination"
          :disabled="!canPrevPage() || $apollo.loading"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn class="page-count-size" outlined color="#c9242b">{{ page }}</v-btn>
        <v-btn
          class="ma-2 page-arrow-size"
          outlined
          color="#707070"
          @click="onClickNextPagination"
          :disabled="!canNextPage() || $apollo.loading"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <button
          class="hover:tw-bg-light-gray tw-px-4 tw-py-2 tw-rounded-md"
          v-on:click="showPagination = !showPagination"
        >
          <span>{{ getPageDesc() }}</span>
        </button>
        <div class="tw-absolute tw-right-0 tw-bg-white tw-w-52 tw-shadow-lg tw-rounded-md tw-p-2" v-if="showPagination">
          <v-radio-group :value="itemsPerPage" column @change="onChangePagination">
            <v-radio label="แสดงหน้าละ 10 รายการ" color="#6ec39b" value="10"></v-radio>
            <v-radio label="แสดงหน้าละ 30 รายการ" color="#6ec39b" value="30"></v-radio>
            <v-radio label="แสดงหน้าละ 50 รายการ" color="#6ec39b" value="50"></v-radio>
          </v-radio-group>
        </div>
      </div>
    </div>
    <!-- <PurchaseReport :openDialog="openPurchaseDialog" :doc="purchaseDialogDoc" v-on:close-dialog="closeDialog" /> -->
  </v-card>
</template>

<script>
import Vue from "vue"
import { mapState } from "vuex"
import purchase from "@/store/collection/purchase"
import fc from "@/firebaseConfig"
import firebase from "firebase/app"
import "firebase/auth"
// import zipFiles from "@/libs/zipFiles";
import isMobile from "../../../libs/detectMobile"
import moment from "moment-timezone"
import "moment/locale/th"
// import PopoverMenu from "./popoverMenu"
import formatTwoDecimal from "@/libs/formatTwoDecimal"
import getErrorMessage from "@/libs/getErrorMessage"
import { docsQuery } from "../../../store/collection/purchase"
import companyStatus from "@/libs/companyStatus"
// import PurchaseReport from "./purchase.report"
import libCSV from "@/libs/libCSV"
import { createKBankMCLTxt } from '@/libs/ewht/kbank/mcl'
import { createKBankDCTTxt } from '@/libs/ewht/kbank/dct'
import { createKBankFTLTxt } from '@/libs/ewht/kbank/ftl'
const downloadjs = require('downloadjs')
// const windows874 = require('windows-874')

const axios = require("axios")
const _ = require("lodash")

moment.locale("th")

export default {
  components: {
    // PopoverMenu,
    // PurchaseReport,
  },
  data() {
    return {
      openPurchaseDialog: false,
      purchaseDialogDoc: {},
      selectedAll: false,
      emailDialog: false,
      email: "",
      emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
      emailValid: false,
      sendEmailLoading: false,
      sendEmailSuccessCount: 0,
      alert: {
        text: "",
        type: "success",
        show: false,
      },
      pdfDialog: false,
      pdfSrc: "",
      downloadPdfLoading: false,
      optionFilterList: [
        { label: "ดาวน์โหลดแล้ว", key: "@DownloadedXml" },
        { label: "ยังไม่ได้ดาวน์โหลด", key: "not-download" },
      ],
      defaultValueFilterList: ["@DownloadedXml", "not-download"],
      optionHideList: [
        { label: "แสดงทั้งหมด", key: "all" },
        { label: "วันที่เอกสาร", key: "paymentDocDate" },
        { label: "เลขผู้เสียภาษี", key: "payeeTaxID" },
        { label: "อ้างอิงเอกสารเลขที่", key: "payeeReference" },
        { label: "ชื่อผู้ซื้อ / ชื่อบริษัท", key: "payeeName" },
        { label: "จำนวนเงินภาษีหัก ณ ที่จ่าย", key: "whtAmount" },
        { label: "ภาษีมูลค่าเพิ่ม", key: "invoiceVatAmount" },
        { label: "มูลค่าที่นำมาคิดภาษีหัก ณ ที่จ่าย", key: "invoiceBaseAmount" },
        { label: "จำนวนเงินสุทธิ", key: "invoiceTotalNetAmount" },
      ],
      valueHideList: [
        "all",
        "paymentDocDate",
        "payeeTaxID",
        "payeeReference",
        "payeeName",
        "whtAmount",
        "invoiceVatAmount",
        "invoiceBaseAmount",
        "invoiceTotalNetAmount",
      ],
      defaultValueHideList: [
        "all",
        "paymentDocDate",
        "payeeTaxID",
        "payeeReference",
        "payeeName",
        "whtAmount",
        "invoiceVatAmount",
        "invoiceBaseAmount",
        "invoiceTotalNetAmount",
      ],
      disablePopOver: false,
      mouse: false,
      dragging: false,
      height: 0,
      resize: false,
      //filter
      filter: {
        issueDateTimeRange: [],
        objectId: "",
        scttAhtaBtpId: "",
        buyerBranchId: "",

        typeLineTotal: "",
        lineTotal: [],

        typeTaxTotal: "",
        taxTotal: [],

        typeGrandTotal: "",
        grandTotal: [],

        timeSignedXmlRange: [],
        docType: "",
        status: {
          downloadedXml: null,
          signSuccess: null,
          missingInfo: null,
          mailSent: null,
          suspendedAccount: null,
          buyerEmail_Isnull: null,
        },
      },
      channelType: {
        1: "Shopee",
        2: "Lazada",
      },
      // pagination
      pageInfo: null,
      totalCount: 0,
      edgeCount: 0,
      page: 1,
      itemsPerPage: localStorage.getItem("pageLimit") === "auto" ? "10" : localStorage.getItem("pageLimit"), // hardcode for auto case
      first: localStorage.getItem("pageLimit") === "auto" ? "10" : localStorage.getItem("pageLimit"),
      after: null,
      last: null,
      before: null,
      hasNextPage: null,
      hasPreviousPage: null,
      startCursor: null,
      endCursor: null,
      showPagination: false,

      // gql
      skipQuery: true,

      // email
      emailList: {},
      emailInput: "",
      awaitingDrag: false,
      timer: false,
      sentEmailHover: false,

      // export
      menuDatePickerStart: false,
      menuDatePickerEnd: false,
      exportDialog: false,
      dateExportStart: "",
      dateExportEnd: "",
    }
  },
  created() {
    this.onResetPage()
    this.query()
    let resizeId
    window.addEventListener("resize", () => {
      clearTimeout(resizeId)
      resizeId = setTimeout(this.handleResize, 100)
    })
    this.handleResize()
  },
  beforeDestroy() {
    this.$store.dispatch("purchase/getDocListUnsubscribe")
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  computed: mapState({
    docs: (state) => state.purchase.list,
    loading: (state) => state.docs.loading,
    // page: state => state.docs.page,
    keyword: (state) => state.purchase.keyword,
    downloaded: (state) => state.docsDownloaded.downloaded,
    downloadingXml: (state) => state.docsDownloaded.downloadingXml,
    downloadingPdf: (state) => state.docsDownloaded.downloadingPdf,
    selectedBranch: (state) => state.companies.selectedBranch,
    orderBySelect: (state) => state.purchase.orderBySelect,
    valueFilterList: (state) => state.purchase.valueFilterList,
    selectedList: (state) => state.purchase.selectedList,
    showPaginationTemplate: (state) => state.purchase.showPaginationTemplate,
    companyStatus: (state) => state.statusesByCompany.companyStatus,
    globalLoading: (state) => state.loading.globalLoading,
  }),
  watch: {
    selectedBranch: {
      handler: function () {
        this.query()
      },
    },
    $route() {
      this.clearValue()
      this.query()
    },
    valueFilterList: {
      handler: function () {
        this.query()
      },
    },
    selectedList: {
      handler: function () {
        this.checkSelectedAll()
      },
    },
    docs: {
      handler: function () {
        this.checkSelectedAll()
      },
    },
    height: {
      handler: function () {
        this.matchHeight()
      },
    },
  },
  methods: {
    closeDialog() {
      this.openPurchaseDialog = false
    },
    renderChannelType(type) {
      if (!type) return ""
      return this.channelType[type]
    },
    startDrag() {
      this.timer = false
      this.dragging = false
      this.mouse = true
    },
    stopDrag(doc) {
      if (!this.dragging && this.mouse) {
        // this.onClickDocId(doc['@SignedPdfUrl'])
        // this.onClickDocId(doc)
        this.purchaseDialogDoc = doc
        this.openPurchaseDialog = true
      }
      this.dragging = false
      this.mouse = false
    },
    doDrag() {
      if (this.mouse && !this.awaitingDrag) {
        this.timer = setTimeout(() => {
          this.dragging = true
          this.awaitingDrag = false
        }, 200)
        this.awaitingDrag = true
      }
    },
    matchHeight() {
      if (localStorage.getItem("pageLimit") !== "auto") return
      let cardTitle = document.getElementById("card-title").clientHeight || 0
      let headerTable = document.getElementById("header-table").clientHeight || 0
      let rowDetailRow = Math.floor((this.height - (150 + cardTitle + headerTable)) / 67)
      let pageLimit = 10
      pageLimit = rowDetailRow > 1 ? rowDetailRow - 1 : rowDetailRow >= 0 ? rowDetailRow : 1

      localStorage.setItem("pageLimitAuto", pageLimit.toString())
      this.$store.dispatch("user/setPageLimitAutoChange")
      this.clearValue()
      this.query()
    },
    handleResize() {
      this.height = window.innerHeight
    },
    getTaxId: function (taxID) {
      let taxIDShow = "-"
      if (taxID && taxID.length > 13) {
        taxIDShow = taxID.substring(0, 13)
      } else if (taxID && taxID.length <= 13) {
        taxIDShow = taxID
      }
      return taxIDShow
    },
    getCheckedSelect: function (docID) {
      return this.selectedList.some((x) => x["docID"] === docID)
    },
    getFormatAmount(amount) {
      return formatTwoDecimal(amount)
    },
    timeFormat: function (timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate()).add(543, "years").format("Do MMM YY, LTS")
      }
      return "-"
    },
    query: function () {
      let companyId = this.$route.params.companyId
      if (companyId) {
        this.$store.dispatch("purchase/getList", {
          id: companyId,
          selectedBranch: this.selectedBranch,
        })
      }
    },
    getEmailList: function () {
      for (let e of this.selectedList) {
        if (e.docID) {
          if (!this.emailList[e.docID]) {
            this.emailList[e.docID] = []
          }
          if (e.buyerEmail) {
            this.emailList[e.docID] = Vue.observable(e.buyerEmail.replaceAll(";", ",").split(","))
          } else {
            this.emailList[e.docID] = Vue.observable([])
          }
        }
      }
    },
    clearEmailList: function () {
      this.emailDialog = false
      this.emailList = {}
    },
    exportDocs() {
      const companyID = this.$route.params.companyId
      const timeStart = moment(this.dateExportStart + "T00:00:00.000+07:00")
      const timeEnd = moment(this.dateExportEnd + "T00:00:00.000+07:00").add(1, "days")

      let q = fc.db.collection(`Companies/${companyID}/DocsPurchase`)
      q = q.where(new firebase.firestore.FieldPath("paymentDocDate"), ">=", timeStart.toDate())
      q = q.where(new firebase.firestore.FieldPath("paymentDocDate"), "<", timeEnd.toDate())
      q = q.orderBy(new firebase.firestore.FieldPath("paymentDocDate"))
      q.get().then((querySnapshot) => {
        const rows = [
          [
            "วันที่เอกสาร", // paymentDocDate
            "เลขที่ใบสั่งขาย", // payeeReference
            "ชื่อผู้ซื้อ/ชื่อบริษัท", // payeeName
            // "มูลค่าสินค้า/บริการ",
            // "มูลค่าที่นำมาคิดภาษี",
            // "ภาษีมูลค่าเพิ่ม",
            "ยอดรวม", // whtAmount
            "เลขที่ใบกำกับภาษี", // @DBSaleDocID
            "ช่องทางการขาย", // payeeTaxID this.channelType[type]
          ],
        ]
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          rows.push([
            [
              moment(data["paymentDocDate"].toDate()).tz("Asia/Bangkok").format("YYYY-MM-DD"),
              data["payeeReference"],
              data["payeeName"],
              // "มูลค่าสินค้า/บริการ",
              // "มูลค่าที่นำมาคิดภาษี",
              // "ภาษีมูลค่าเพิ่ม",
              libCSV.stangToTHB(data["whtAmount"]),
              data["@DBSaleDocID"],
              this.channelType[data["payeeTaxID"]],
            ],
          ])
        })
        libCSV.exportCSV(`Purchase_${this.dateExportStart}_${this.dateExportEnd}.csv`, rows)
        this.exportDialog = false
      })
    },
    cancelExportDialog() {
      this.exportDialog = false
    },
    clickSelectedAll: function (checked) {
      let selectedList = _.cloneDeep(this.selectedList)
      if (checked) {
        purchase.state.list.forEach((doc) => {
          if (!selectedList.some((x) => x["docID"] === doc.id)) {
            let data = doc
            data.docID = doc.id

            selectedList.push(data)
          }
        })
      } else {
        purchase.state.list.forEach((doc) => {
          let index = selectedList.findIndex((x) => x["docID"] === doc.id)
          if (index !== -1) {
            selectedList.splice(index, 1)
          }
        })
      }
      this.$store.dispatch("purchase/setSelectedList", { selectedList: selectedList })
    },
    clickSelected: function (doc) {
      let valueList = _.cloneDeep(this.selectedList)
      if (this.getCheckedSelect(doc.id)) {
        let index = valueList.findIndex((x) => x["docID"] === doc.id)
        valueList.splice(index, 1)
      } else {
        console.log(doc)
        let data = doc
        data.docID = doc.id
        valueList.push(data)
      }

      this.$store.dispatch("purchase/setSelectedList", { selectedList: valueList })
    },
    checkSelectedAll: function () {
      let selectedAll = false
      let checkCount = 0
      this.selectedList.forEach((select) => {
        if (purchase.state.list.some((doc) => doc.id === select.docID)) {
          checkCount++
        }
      })
      if (checkCount === purchase.state.list.length && purchase.state.list.length > 0) {
        selectedAll = true
      }
      this.selectedAll = selectedAll
    },
    debounceInput: _.debounce(function (keyword) {
      this.changeKeyword(keyword)
    }, 1000),
    changeKeyword: function (keyword) {
      this.clearValue()
      let companyId = this.$route.params.companyId

      if (companyId) {
        this.$store.dispatch("purchase/updateKeyword", { id: companyId, keyword: keyword })
        if (keyword) {
          this.$apollo.queries.docs.skip = false
          this.$apollo.queries.docs.start()
          this.$store.dispatch("purchase/setShowPaginationTemplate", { val: false })
        } else {
          this.$apollo.queries.docs.skip = true
          this.query()
          this.$store.dispatch("purchase/setShowPaginationTemplate", { val: true })
        }
        // this.query();
        let resizeId
        window.addEventListener("resize", () => {
          clearTimeout(resizeId)
          resizeId = setTimeout(this.handleResize, 100)
        })
        this.handleResize()
      }

      // if search disable filter
      if (keyword) {
        this.disablePopOver = true
      } else {
        this.disablePopOver = false
      }
    },
    validateEmail: function () {
      if (this.$refs.form.validate()) {
        this.emailDialog = false
        this.sendEmail()
      }
    },
    sendEmail: async function () {
      this.sendEmailLoading = true

      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken
        })
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      }
      // let allEmailFill = (this.emailList.join(',').replaceAll(';',',')).split(",")
      // let allEmailSelected = (this.selectedList.map(select => {
      //   return select['buyerEmail'].replaceAll(';',',')
      // }))
      // allEmailSelected = (allEmailSelected.join(',')).split(',')
      // let emailWouldSend = []
      // for(let e of allEmailFill) {
      //   if(!allEmailSelected.includes(e)){
      //     emailWouldSend.push(e)
      //   }
      // }
      // const promises = this.selectedList.map(async (select) => {
      //   let allEmailSend = select['buyerEmail'].replaceAll(';',',')
      //   if(emailWouldSend.length>0){
      //     if(allEmailSend) {
      //       allEmailSend += ',' + emailWouldSend.join(',')
      //     }else{
      //       allEmailSend = emailWouldSend.join(',')
      //     }
      //   }
      //   let data = {
      //     company_id: this.$route.params.companyId,
      //     invoice_id: select['docID'],
      //     email: allEmailSend,
      //   }

      //   await axios.post(fc.cloudFunctionUrl + "sendemail", data, {headers})
      //     .then((response) => {
      //       if (response.status === 200) {
      //         this.sendEmailSuccessCount++
      //       }

      //     }, (error) => {
      //       console.log(error)
      //     });
      // })
      const promises = Object.keys(this.emailList).map(async (k) => {
        let data = {
          company_id: this.$route.params.companyId,
          invoice_id: k,
          email: this.emailList[k].join(","),
        }

        await axios.post(fc.cloudFunctionUrl + "sendemail", data, { headers }).then(
          (response) => {
            if (response.status === 200) {
              this.sendEmailSuccessCount++
            }
          },
          (error) => {
            console.log(error)
          }
        )
      })

      await Promise.all(promises)
      if (this.sendEmailSuccessCount === this.selectedList.length) {
        this.alert = { text: "ส่งอีเมลสำเร็จ " + this.sendEmailSuccessCount + " รายการ", type: "success", show: true }

        this.sendEmailSuccessCount = 0

        this.query()
      }
      this.sendEmailLoading = false
      this.emailDialog = false
      this.email = ""
      this.emailList = {}
    },
    changeOrderBy: function (order) {
      let orderBySelect = _.cloneDeep(this.orderBySelect)
      if (!(this.orderBySelect["key"] === order)) {
        orderBySelect = { key: order, value: "asc" }
      } else {
        if (_.get(orderBySelect, "value") === "asc") {
          _.set(orderBySelect, "value", "desc")
        } else {
          orderBySelect = {}
        }
      }
      this.$store.dispatch("purchase/setOrderBySelect", { orderBySelect: orderBySelect })
      this.$store.dispatch("purchase/updatePage", { page: 1 })
      this.query()
    },
    downloadPDF: function () {
      // zipFiles(this.$route.params.companyId, this.selected, "pdf", '@SignedPdfUrl', this.$store.dispatch)
      this.downloadZip("pdf")
    },
    downloadXML: function () {
      // zipFiles(this.$route.params.companyId, this.selected, "xml", '@SignedXmlUrl', this.$store.dispatch)
      this.downloadZip("xml")
    },
    loadingDownloadZip: function (type, onOff) {
      let boolean = onOff === "on"
      if (type === "xml") this.$store.dispatch("docsDownloaded/updateDownloadingXml", { downloadingXml: boolean })
      else this.$store.dispatch("docsDownloaded/updateDownloadingPdf", { downloadingPdf: boolean })
    },
    downloadZip: async function (type) {
      this.loadingDownloadZip(type, "on")
      let urlField = "pdfUrl"
      if (type === "xml") {
        urlField = "xmlUrl"
      }
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken
        })
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      }
      let docList = []
      let timeStamp = new Date().getTime()
      // เอาเฉพาะแถวที่มี url
      await this.selectedList.forEach((docSelect) => {
        if (docSelect[urlField]) {
          docList.push({ id: docSelect["docID"], url: docSelect[urlField] })
        }
      })
      await axios
        .post(
          fc.cloudFunctionUrl + "zipFiles",
          { data: docList, type: type, companyID: this.$route.params.companyId },
          { headers, responseType: "arraybuffer" }
        )
        .then(
          (result) => {
            if (result.data.byteLength !== 0) {
              let url = URL.createObjectURL(new Blob([result.data], { type: "application/zip" }))
              const link = document.createElement("a")
              link.href = url
              link.setAttribute("download", timeStamp + ".zip")
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(url)
            }
            this.loadingDownloadZip(type, "off")
            this.clearSelectList()
          },
          (error) => {
            console.log("front end error: ", error)
            this.loadingDownloadZip(type, "off")
          }
        )
    },
    // onClickDocId: async function (pdfLink) {
    //   if (!pdfLink) {
    //     this.alert = {text: "Signer ยังไม่ได้สร้าง Pdf ให้เอกสารนี้", type: "error", show: true}
    //     return
    //   }

    //   this.downloadPdfLoading = true

    //   if (!this.pdfDialog) {
    //     await axios.get(pdfLink, {
    //       responseType: 'arraybuffer',
    //     })
    //       .then((response) => {
    //         this.downloadPdfLoading = false

    //         let url = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));

    //         if (isMobile()) {
    //           let a = document.createElement("a");
    //           document.body.appendChild(a);
    //           a.style = "display: none";
    //           a.href = url;
    //           a.download = "invoice_" + new Date().getTime() + ".pdf";
    //           a.click();
    //           window.URL.revokeObjectURL(url);

    //         } else {
    //           this.pdfSrc = url
    //           this.pdfDialog = true
    //         }

    //       }, (error) => {
    //         console.log(error)
    //       });
    //   }
    // },

    onClickDocId: async function (doc) {
      this.$store.dispatch("setGlobalLoading", true)
      this.downloadPdfLoading = true

      let pdfLink = doc["@SignedPdfUrl"]
      if (!pdfLink) {
        this.alert = { text: "Signer ยังไม่ได้สร้าง Pdf ให้เอกสาร " + doc["objectID"], type: "error", show: true }
      }
      let unsigedPdfLink = doc["@UnsignedPdfUrl"]

      let link = ""
      if (!pdfLink && !unsigedPdfLink) {
        link = await this.updateUnsignedPdf(doc["objectID"])
      } else if (pdfLink) {
        link = pdfLink
      } else if (unsigedPdfLink) {
        link = unsigedPdfLink
      }

      if (!this.pdfDialog && link) {
        await axios
          .get(link, {
            responseType: "arraybuffer",
          })
          .then(
            (response) => {
              this.downloadPdfLoading = false

              let url = URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }))

              if (isMobile()) {
                let a = document.createElement("a")
                document.body.appendChild(a)
                a.style = "display: none"
                a.href = url
                a.download = "invoice_" + new Date().getTime() + ".pdf"
                a.click()
                window.URL.revokeObjectURL(url)
              } else {
                this.pdfSrc = url
                this.pdfDialog = true
              }
            },
            (error) => {
              console.log(error)
            }
          )
      }
      this.$store.dispatch("setGlobalLoading", false)
    },
    updateUnsignedPdf: async function (docID) {
      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken
        })
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      }
      let data = {
        companyID: this.$route.params.companyId,
        docID: docID,
      }
      const promise = new Promise((resolve, reject) => {
        axios.post(fc.cloudFunctionUrl + "updateUnsignedPdf", data, { headers }).then(
          (response) => {
            if (response.status === 200) {
              resolve(response.data)
            }
          },
          (error) => {
            reject(error)
            console.log(error)
          }
        )
      })
      return promise
    },

    getDateWithFormat: function (date) {
      var parsedDate = moment(date);

      // Format the date as per the desired output format
      var formattedDate = parsedDate.format("Do MMM", "th");

      // Convert the month to Thai abbreviation
      formattedDate = formattedDate.replace("Jan", "ม.ค.");
      formattedDate = formattedDate.replace("Feb", "ก.พ.");
      formattedDate = formattedDate.replace("Mar", "มี.ค.");
      formattedDate = formattedDate.replace("Apr", "เม.ย.");
      formattedDate = formattedDate.replace("May", "พ.ค.");
      formattedDate = formattedDate.replace("Jun", "มิ.ย.");
      formattedDate = formattedDate.replace("Jul", "ก.ค.");
      formattedDate = formattedDate.replace("Aug", "ส.ค.");
      formattedDate = formattedDate.replace("Sep", "ก.ย.");
      formattedDate = formattedDate.replace("Oct", "ต.ค.");
      formattedDate = formattedDate.replace("Nov", "พ.ย.");
      formattedDate = formattedDate.replace("Dec", "ธ.ค.");

      // Get the year in Thai Buddhist calendar
      var thaiYear = parseInt(parsedDate.format("YYYY")) + 543; // Add 543 to convert to Thai Buddhist calendar

      // Append the Thai Buddhist year to the formatted date
      formattedDate += " " + thaiYear.toString().substring(2,4);

      return formattedDate;
    },
    onChangeValueFilterList(value) {
      this.clearValue()
      this.$store.dispatch("purchase/setValueFilterList", { valueFilterList: value })
    },
    onChangeValueDropdownHideColumn(value) {
      this.valueHideList = value
    },
    showColumn(field) {
      return this.valueHideList.includes(field)
    },
    clearValue: function () {
      this.$store.dispatch("purchase/updatePage", { page: 1 })
    },
    clearSelectList: function () {
      this.$store.dispatch("docs/setSelectedList", { selectedList: [] })
    },
    errorsMessage: function (errors) {
      return getErrorMessage(errors)
    },
    onResetPage: function () {
      this.totalCount = 0
      this.edgeCount = 0
      this.page = 1
      this.itemsPerPage = localStorage.getItem("pageLimit") === "auto" ? "10" : localStorage.getItem("pageLimit") // hardcode for auto case
      this.first = localStorage.getItem("pageLimit") === "auto" ? "10" : localStorage.getItem("pageLimit")
      this.after = null
      this.last = null
      this.before = null
      this.hasNextPage = null
      this.hasPreviousPage = null
      this.startCursor = null
      this.endCursor = null
    },
    onClickNextPagination: function () {
      this.page += 1
      this.first = this.itemsPerPage
      this.after = this.endCursor
      this.last = null
      this.before = null

      this.hasPreviousPage = true
      this.pageInfo.hasPreviousPage = true
      this.hasNextPage = null
      this.pageInfo.hasNextPage = null

      this.clearAllSelectList()
    },
    onClickPreviousPagination: function () {
      this.page -= 1
      this.last = this.itemsPerPage
      this.before = this.startCursor

      this.first = null
      this.after = null

      this.hasPreviousPage = null
      this.pageInfo.hasPreviousPage = null
      this.hasNextPage = true
      this.pageInfo.hasNextPage = true

      this.clearAllSelectList()
    },
    canNextPage() {
      console.log("can next page", this.loading)
      if (this.hasNextPage !== null) {
        return this.hasNextPage
      } else if (this.pageInfo) {
        return this.pageInfo.hasNextPage
      } else {
        return false
      }
    },
    canPrevPage() {
      if (this.hasPreviousPage !== null) {
        return this.hasPreviousPage
      } else if (this.pageInfo) {
        return this.pageInfo.hasPreviousPage
      } else {
        return false
      }
    },
    getPageDesc() {
      let lastRow = this.page * this.itemsPerPage
      if (lastRow > this.totalCount) {
        lastRow = this.totalCount
      }
      let startRow = this.page * this.itemsPerPage - (this.itemsPerPage - 1)
      return `${startRow} - ${lastRow} จาก ${this.totalCount}`
    },
    onChangePagination(pageLimit) {
      this.loading = true
      let user = firebase.auth().currentUser
      let companyId = this.$route.params.companyId
      if (companyId) {
        this.$store
          .dispatch("user/updatePageLimitSetting", {
            companyId: companyId,
            userId: user.uid,
            pageLimit: pageLimit,
          })
          .then(() => {
            this.page = 1
            this.itemsPerPage = pageLimit
            this.first = pageLimit
            this.after = null
            this.last = null
            this.before = null
            this.hasNextPage = null
            this.hasPreviousPage = null
            this.startCursor = null
            this.endCursor = null

            this.showPagination = false
            this.loading = false
          })
      }
    },
    clearAllSelectList: function () {
      this.selectAll = false
      this.$store.dispatch("purchase/setSelectedList", { selectedList: [] })
      this.clearSelectList()
    },
    holdDownloadAndSendEmail: function (status) {
      return companyStatus.holdDownloadAndSendEmail(status)
    },
    autocompleteAddEmail: function (k, value) {
      this.emailInput = ""
      if (value && !this.emailList[k].includes(value)) {
        Vue.observable(this.emailList[k].push(value))
      }
    },
    removeEmail: function (k) {
      this.emailList[k] = [...this.emailValues[k]]
      Vue.observable(this.emailList[k])
    },

    // 000001 123456789012 1111111111111111 000000000010001 180515 นาย                     สรัน ดำรงกิตติกุล                                  TH saran.pol@gmail.com                                M0876737951         11111110876737951
    // 000002 123456789012 1111111111111111 000000000010002 180515 นาย                     สรัน ดำรงกิตติกุล                                  TH saran.pol@gmail.com                                I3509900149467      11111110876737951
    padNumber (num, size) {
      let s = num + ''
      while (s.length < size) s = '0' + s
      return s
    },
    padText (s, size) {
      while (s.length < size) s = s + ' '
      return s
    },
    getAfterTaxValue (v) {
      const maxAmountForTax = 1000.0
      if (v >= maxAmountForTax) {
        return Math.round(v * 0.95 * 100.0) / 100
      }
      return v
    },

    clickExportWHTTxtSelected (bank) {
      // const cusID = '400959025244' // HLP
      // const cusID = '400959028399' // SMY
      let i = 0
      let data = ''
      const date = new Date()
      // const effectiveDate = moment(date).add(4, 'days').format('YYMMDD')
      const dateString = moment(date).format('YYYY-MM-DD_HH-mm-ss')
      // let totalV = 0
      let dNow = moment().tz("Asia/Bangkok")
      for (let inv of this.selectedList) {
        i++
        // data += this.padNumber(i, 6) + ' '
        // data += cusID + ' '
        // data += this.padText('11111111111', 16) + ' '
        // let amountAfterTax = this.getAfterTaxValue(inv.whtAmount)
        // const v = Math.round(amountAfterTax * 100.0)
        // totalV += v
        // data += this.padNumber(v, 15) + ' '
        // data += effectiveDate + ' '
        // data += this.padText('', 23) + ' '
        // const name = inv.payeeName
        // data += this.padText(name, 50) + ' '
        // data += 'TH' + ' '
        // data += this.padText(inv.payeeEmail, 50) + ' '
        // if (inv.payeeTaxID) {
        //   data += 'I' + this.padText(inv.payeeTaxID, 19)
        // } else if (inv.payeeMobile) {
        //   data += 'M' + this.padText(inv.payeeMobile, 19)
        // }
        // data += '111'
        // data += '1111'
        // data += this.padText(inv.payeeMobile, 23)
        // data += '\n'

        switch(bank) {
          case 'ktb':
            data +=`${i}|${inv.payeeTaxID}||${inv.payeeName}|${moment(inv.paymentDocDate).tz("Asia/Bangkok").format("DD/MM/YYYY")}|${inv.whtName}|${inv.whtRate}|${inv.invoiceBaseAmount}|${inv.whtAmount}|${inv.whtConditionType}`
            data += '\n'
            break
          case 'tmb':
            data += this.padText('TXN', 3)
            data += this.padText(inv.payerName, 120)
            data += this.padText(inv.payeeName, 130)
            data += this.padText(inv.payeeName+inv.payeeEmail, 40)
            data += this.padText(' ', 40)
            data += this.padText(' ', 40)
            data += this.padText(' ', 40)
            data += this.padText(' ', 40)
            data += this.padText(' ', 10)
            data += this.padText(' ', 16)
            data += this.padText(moment(inv.paymentDocDate).tz("Asia/Bangkok").format("DDMMYYYY"), 8)
            data += this.padText(moment(inv.paymentDocDate).tz("Asia/Bangkok").format("DDMMYYYY"), 8)
            data += this.padText(inv.payeeCurrency, 3)
            
            data += this.padText(' ', 15)
            data += this.padText(' ', 15)
            data += this.padText(inv.payeeTaxID, 20)
            data += this.padText(inv.payerBankAccount, 20)
            data += this.padText(inv.invoiceTotalNetAmount, 15)
            data += this.padText(inv.payeeBankCode, 16)
            data += this.padText(inv.payeeBankAccount, 20)
            data += this.padText('04', 2)
            data += this.padText('00', 2)
            data += this.padText('OC', 2)
            data += this.padText(inv.payeeBankBranchCode, 20)
            data += this.padText('EMAIL', 5)
            data += this.padText(inv.payeeFax, 50)
            data += this.padText(inv.payeeEmail, 50)
            data += this.padText(inv.payeeMobile, 50)
            data += this.padText('OUR', 13)
            data += this.padText('MCP', 3)
            data += this.padText(' ', 5)
            data += this.padText(' ', 4)
            data += this.padText('REC', 30)
            data += this.padText(inv.paymentDetail, 105)
            data += this.padText(' ', 70)
            data += this.padText(' ', 40)
            data += this.padText(' ', 40)
            data += this.padText(' ', 40)
            data += this.padText(' ', 40)
            data += this.padText(' ', 16)
            data += this.padText(' ', 7)
            data += this.padText(' ', 2)
            data += this.padText(' ', 15)
            data += this.padText(' ', 16)
            data += this.padText(' ', 10)
            data += this.padText(' ', 100)
            data += this.padText(' ', 16)
            data += this.padText(' ', 17)
            data += this.padText(' ', 10)
            data += this.padText(inv.payerTaxID, 100)
            data += this.padText(' ', 10)
            data += this.padText(inv.payeeTaxID, 100)
            data += this.padText(inv.payeeMobile, 20)
            data += this.padText(' ', 100)
            data += this.padText(' ', 130)
            data += this.padText(' ', 20)
            data += this.padText(' ', 100)
            data += this.padText(' ', 130)
            data += this.padText(' ', 20)
            data += this.padText(' ', 100)
            data += this.padText(' ', 130)
            data += this.padText(' ', 15)
            data += this.padText(' ', 8)
            data += this.padText(' ', 8)
            data += this.padText(' ', 8)
            data += this.padText(' ', 20)
            data += this.padText(' ', 79)
            data += this.padText('END', 3)
            data += '\n'
            break
          case 'bbl':
            data += `001~${inv.payerName}~${inv.payerTaxID}~~~${dNow.format("DDMMYYYY")}~${dNow.format("HHmmss")}\n`
            data += `003~${inv.payerName}~${i}~SMC04~${inv.payeeBankAccount}~${inv.paymentDocDate}~~THB~~Y~~~${inv.whtCode}~~~~04~~~~~OUR~${inv.invoiceTotalNetAmount}~~~${inv.paymentDocDate}~${inv.payeeBankCode}~${inv.payeeBankBranchCode}~B~~~~${inv.payeeName}~~~~~~~~~${inv.payeeTaxID}~~~${inv.payeeEmail}\n`
            data += `005~${inv.CardCode}~1~${inv.whtAmount}~${inv.whtCode}~${inv.whtRate}~${inv.invoiceTotalAmount}\n`
            data += `009~${inv.payeeDocNum}_${inv.purchaseOrderNo}_${moment(inv.paymentDocDate).tz("Asia/Bangkok").format("DDMMYYYY")}~${inv.invoiceTotalAmount}~${inv.paymentDetail}~${inv.invoiceVatAmount}~~${inv.whtCode}\n`
            break
        }
      }
      // data += this.padNumber(i, 6) + ' '
      // data += '9100' + ' '
      // data += cusID + ' '
      // data += this.padNumber(totalV, 15) + ' '
      // data += '000000'
      
      // const dataWindows874 = windows874.encode(data)
      downloadjs(data, bank+'_wht_' + dateString + '.txt', 'text/plain')
      // downloadjs(dataWindows874, 'prompt_pay_' + dateString + '.txt', 'text/plain')
      // console.log(data)
    },
    clickExportWHTKbankTxtSelected(type) {
      let data = ''
      const date = new Date()
      // const effectiveDate = moment(date).add(4, 'days').format('YYMMDD')
      const dateString = moment(date).format('YYYY-MM-DD_HH-mm-ss')
      switch(type) {
        case 'dct':
          data += createKBankDCTTxt(this.selectedList)
          break

        case 'mcl':
          data += createKBankMCLTxt(this.selectedList)
          break

        case 'ftl':
          data += createKBankFTLTxt(this.selectedList)
          break

        default:
          console.error('unsupported type: ' + type)
          break
      }
      console.log(type)
      console.log(data)
      console.log(dateString)
      // const dataWindows874 = windows874.encode(data)
      if (data)
        downloadjs(data,`kbank_${type}_wht_${dateString}.txt`, 'text/plain')
    },
  },
  apollo: {
    docs: {
      query() {
        return docsQuery
      },
      variables() {
        return {
          companyId: this.$route.params.companyId,
          // companyId: 1, // test
          order: this.order,
          // search: this.search,
          search: purchase.state.keyword,

          // pagination
          first: this.first,
          after: this.after,

          last: this.last,
          before: this.before,

          //filter
          issueDateTimeRange: this.filter.issueDateTimeRange,
          objectId: this.filter.objectId,
          scttAhtaBtpId: this.filter.scttAhtaBtpId,
          buyerBranchId: this.filter.buyerBranchId,

          typeLineTotal: this.filter.typeLineTotal,
          lineTotal: this.filter.lineTotal,

          typeTaxTotal: this.filter.typeTaxTotal,
          taxTotal: this.filter.taxTotal,

          typeGrandTotal: this.filter.typeGrandTotal,
          grandTotal: this.filter.grandTotal,

          timeSignedXmlRange: this.filter.timeSignedXmlRange,
          docType: this.filter.docType,

          //status
          downloadedXml: this.filter.status.downloadedXml,
          signSuccess: this.filter.status.signSuccess,
          hasError: this.filter.status.missingInfo,
          mailSent: this.filter.status.mailSent,
          suspendedAccount: this.filter.status.suspendedAccount,
          buyerEmail_Isnull: this.filter.status.buyerEmail_Isnull,
        }
      },
      result({ data, loading }) {
        let pageInfo = data.docs["pageInfo"]
        this.pageInfo = pageInfo
        this.startCursor = pageInfo.startCursor
        this.endCursor = pageInfo.endCursor
        this.totalCount = data.docs["totalCount"]
        this.edgeCount = data.docs["edgeCount"]
        if (data.docs["edges"]) {
          this.documentList = data.docs["edges"]
        }

        this.$store.dispatch("purchase/setDocsData", this.documentList)
        this.$store.dispatch("purchase/setLoading", loading)
      },
      // Disable the query
      skip() {
        return this.skipQuery
      },
      error(error) {
        console.error("We've got an error!", error)
      },
    },
  },
}
</script>

<style lang="scss">
#table-firebase {
  .filter-up {
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  th {
    img {
      width: 10px;
      height: 8px;
    }
  }

  .border-right {
    border-right: 1px solid #ffffff;
  }

  //add arrow to tooltip
  //.v-tooltip__content::before {
  //  content: '';
  //  position: absolute;
  //  display: block;
  //  width: 0px;
  //  left: 50%;
  //  bottom: 6px;
  //  border: 5px solid transparent;
  //  border-bottom: 0;
  //  border-top: 8px solid #191919;
  //  transform: translate(-50%, calc(100% + 5px));
  //}

  .v-text-field fieldset,
  .v-text-field .v-input__control,
  .v-text-field .v-input__slot {
    border-radius: 10px !important;
    border-color: #c4c4c4;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .search-box {
    width: 250px;
  }

  .remove-checkbox-padding {
    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }

  .doc-id {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .v-text-field__details {
    display: none !important;
  }

  .icon-sort {
    cursor: pointer;
  }

  .v-card__title .v-messages {
    min-height: 11px;
  }

  .order-by-row {
    cursor: pointer;
  }

  .icon-downloaded {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 4px;
  }

  th,
  td {
    white-space: nowrap;
  }

  .check-box-flex {
    display: flex;
    align-items: center;
  }

  tr {
    &.tr-data {
      cursor: pointer;
    }
  }
  .icon-button {
    height: -webkit-fill-available;
  }
}

.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}
.disabled-btn {
  color: rgba(0, 0, 0, 0.26) !important;
  cursor: default;
}
</style>
